import React from 'react';
import './Gigs.css';

const gigsData = [
  { date: 'OCT 25', venue: 'FIERA', link: '#', linkText: 'TICKETS' },
  { date: 'DEC 02', venue: 'PHONIQUE', link: '#', linkText: 'RSVP' },
  { date: 'DEC 15', venue: 'DEPARTAMENTO', link: '#', linkText: 'INFO' },
  { date: 'JAN 19', venue: 'PHONIQUE', link: '#', linkText: 'DETAILS' },
];

const Gigs = () => {
  return (
    <section id="dates" className="gigs-section">
      <h2 className="section-title">Upcoming Gigs</h2>
      <ul className="gigs-list">
        {gigsData.map((gig, index) => (
          <li key={index} className="gig-item">
            <span className="gig-date">{gig.date}</span>
            <span className="gig-venue">— {gig.venue} —</span>
            <a href={gig.link} className="gig-link" target="_blank" rel="noopener noreferrer">
              [{gig.linkText}]
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Gigs;
